import { createSelector } from 'reselect';

const playlistState = (state) => state.playlist;

export const currentPlaylistSelector = createSelector(
  playlistState,
  (pls) => pls.current
);
